import { Voltage } from '../../../../../../domain/Voltage';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class VoltageDiffNominalEvaluation {
  private readonly ruleName = 'Lv_EnergyConsumer_VoltageDiffNominal';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(voltageDiffNominal: number): EvaluationResultType<Voltage> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      voltageDiffNominal
    );
    const value = new Voltage(voltageDiffNominal);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
